import { render, staticRenderFns } from "./buyOrderPrice.vue?vue&type=template&id=3cf29825&scoped=true&"
import script from "./buyOrderPrice.vue?vue&type=script&lang=js&"
export * from "./buyOrderPrice.vue?vue&type=script&lang=js&"
import style0 from "./buyOrderPrice.vue?vue&type=style&index=0&id=3cf29825&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf29825",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cf29825')) {
      api.createRecord('3cf29825', component.options)
    } else {
      api.reload('3cf29825', component.options)
    }
    module.hot.accept("./buyOrderPrice.vue?vue&type=template&id=3cf29825&scoped=true&", function () {
      api.rerender('3cf29825', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/buyOrder/components/buyOrderPrice.vue"
export default component.exports